import { Fetcher } from '@this/src/util';

interface AvailableRepositoriesResponse {
  category: string;
  repository: string;
}

export default class AvailableRepositoriesAPI {
  static async list(): Promise<AvailableRepositoriesResponse[]> {
    const res = await Fetcher.get<AvailableRepositoriesResponse[]>(`/arrangement/available_repositories.json`);
    return res;
  }
}
